$(document).ready(function () {

    $(document).on("click", ".confirmLink", function (e) {
        console.log($(this));
        e.preventDefault();
        let link = $(this);
        let ask = $(this).attr('title');
        let bar = $(this).attr('bar');
        if (isDefined(link.data("ask"))) {
            ask = link.data("ask");
        }

        new ConfirmDialog({
            event: e,
            ask: ask,
            bar: {
                title: bar
            }
        }, function (response) {

            if (response === true) {

                var url = link.data("href");
                var ajax = link.data("ajax");

                if (ajax === "on") {
                    $.nette.ajax({
                        url: url
                    });
                } else {
                    window.location.href = url;
                }

            }
        });
    });

});




